import { ClientMarket } from '@prisjakt/web-app-config/types/client-market';
import { Product } from 'src/types';
import { TranslateFunc } from 'src/components/translate';
import { AggregateRating } from 'schema-dts';

export function aggregateRating(
  product: Product,
  market: ClientMarket,
  t: TranslateFunc
): AggregateRating {
  return {
    '@type': 'AggregateRating',
    url: market.domain + product.pathName,
    ratingValue:
      product.aggregatedRatingSummary?.summary.rating.score ||
      product.userReviewSummary?.rating ||
      0,
    ratingCount:
      product.aggregatedRatingSummary?.summary.rating.count ||
      product.userReviewSummary.count ||
      0,
    worstRating: 0,
    bestRating: 5,
    name: t('reviews', 'panel.title'),
  };
}
